import React from 'react';
import './section.css';
import { contacts } from '../../utils/contacts';
import { team } from '../../utils/team';
import { join } from '../../utils/join';
import { values } from '../../utils/values';
import { projects } from '../../utils/projects';
import Work from '../work/Work'
import Value from '../value/Value'

function Section(props) {
    return(
        <section>
            { (() => {
                switch (props.type) {
                case "contact":
                    return(
                        <section>
                            <h2 className="section-title">{props.title}</h2>
                            <p className="section-body">{props.body}</p>
                            {
                                contacts.map((contact, key) =>
                                    <a className="section-gallery" href={contact.link}><img src={contact.img} key={key}/></a>
                                )
                            }
                        </section>
                    );
                case "team":
                    return(
                        <section>
                            <h2 className="section-title">{props.title}</h2>
                            <p className="section-body">{props.body}</p>
                            {
                                team.map((member, key) =>
                                    <a className="section-members" href={member.link}><img src={member.img} key={key}/></a>
                                )
                            }
                        </section>
                    );
                case "button":
                    return(
                        <section>
                            <h2 className="section-title">{props.title}</h2>
                            <p className="section-body">{props.body}</p>
                            <a href="https://forms.gle/zUQU3f7sTzeinhey6"><button>JOIN NOW</button></a>
                        </section>
                    );
                case "value":
                    return(
                        <section>
                            <img className="section-image-dis center-block" src={props.img}/>
                            <h2 className="section-title">{props.title}</h2>
                            <div className="section-body">
                            {
                                values.map((j, key) =>
                                    <Value title={j.title} description={j.description} key={key}/>
                                )
                            }
                            </div>
                        </section>
                    );
                case "info":
                    return(
                        <section>
                            <p className="section-body">{props.body}</p>
                        </section>
                    );
                default:
                    return(
                        <section>
                            <img className="section-image-title center-block" src={props.img}/>
                            <h2 className="section-title">{props.title}</h2>
                            <p className="section-body">{props.body}</p>
                        </section>
                    );
                }
            })()}
        </section>
    );
}

export default Section;